module.exports = function () {
  return "\n    <div class=\"zoom-overlay\" id=\"zoom-overlay\">\n      <div class=\"status\"></div>\n      <!--- <div class=\"controls\"></div> --->\n    </div>\n  ";
};